import React from "react";
import Logo from "@/components/ratl/utility/logo-nav";
import { RT_LOGO_BLACK_URL, RT_LOGO_CTA } from "@/data";

const NavbarLogo: React.FC = () => (
  <a className="w-full" href={RT_LOGO_CTA} aria-label="Home">
    <Logo logoSrc={RT_LOGO_BLACK_URL} />
  </a>
);

export default NavbarLogo;
